module.exports = __webpack_public_path__ + "img/avatar-2.b5d533d0.png";